import React from 'react';
import PropTypes from 'prop-types';
import BarLoader from 'react-spinners/BarLoader';
import styled from 'styled-components';
import colors from 'styles/theme/colors';

const LOADER_WIDTH = 128;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const Loader = ({ withWrapper }) => {
  const loader = <BarLoader loading color={colors.mainColor} width={LOADER_WIDTH} />;
  if (withWrapper) {
    return (
      <LoaderWrapper>
        {loader}
      </LoaderWrapper>
    );
  }

  return loader;
};

Loader.propTypes = {
  withWrapper: PropTypes.bool,
};

Loader.defaultProps = {
  withWrapper: false,
};

export default Loader;
